"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Play = void 0;
const react_1 = __importDefault(require("react"));
const Play = ({ size, color, outline }) => {
    if (outline) {
        return (react_1.default.createElement("svg", { width: size, height: size, viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            react_1.default.createElement("path", { d: "M31 53.697c12.535 0 22.697-10.162 22.697-22.697C53.697 18.465 43.535 8.303 31 8.303 18.464 8.303 8.302 18.465 8.302 31c0 12.535 10.162 22.697 22.698 22.697Z", stroke: color || '#25CFBB', strokeWidth: "3.783", strokeMiterlimit: "10" }),
            react_1.default.createElement("path", { d: "m38.566 31-11.35-7.566v15.132L38.567 31Z", stroke: color || '#25CFBB', strokeWidth: "3.783", strokeLinecap: "round", strokeLinejoin: "round" })));
    }
    return (react_1.default.createElement("svg", { width: size, height: size, fill: "none", viewBox: "0 0 63 63", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M54.536 31.44c0 12.757-10.341 23.098-23.097 23.098-12.756 0-23.097-10.341-23.097-23.097 0-12.756 10.34-23.097 23.097-23.097 12.756 0 23.097 10.34 23.097 23.097Zm-26.947-7.698 11.549 7.699-11.549 7.699V23.742Z", fill: color || '#25CFBB' })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "a" },
                react_1.default.createElement("path", { fill: "#fff", transform: "translate(.644 .644)", d: "M0 0h61.592v61.592H0z" })))));
};
exports.Play = Play;
